module.exports = __webpack_public_path__ + "media/music/9f8e3a1db63c7a8fd976beca7e3546c3.mp3";